// The official "Funded by the European Union" emblem (design system 0.6.0,
// files from the European Commission). EU rules want the emblem, never the
// words alone (UI-GL1). The negative version swaps in on a dark theme. Not
// for emails: those carry no EU statement at all.
import colour from "@convenor/design-system/assets/eu-emblem/funded-by-the-eu-colour.png";
import negative from "@convenor/design-system/assets/eu-emblem/funded-by-the-eu-negative.png";

const LABEL = "Funded by the European Union";

export function EuEmblem({ kiosk = false }: { kiosk?: boolean }) {
  return (
    <span className={kiosk ? "eu-emblem eu-emblem--kiosk" : "eu-emblem"}>
      <img className="eu-emblem__img eu-emblem__img--light" src={colour} alt={LABEL} />
      <img className="eu-emblem__img eu-emblem__img--dark" src={negative} alt={LABEL} />
    </span>
  );
}
